"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoBoneSettingsT = exports.AutoBoneSettings = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * https://github.com/SlimeVR/SlimeVR-Server/blob/v0.8.3/server/src/main/java/dev/slimevr/config/AutoBoneConfig.kt
 */
class AutoBoneSettings {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsAutoBoneSettings(bb, obj) {
        return (obj || new AutoBoneSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsAutoBoneSettings(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new AutoBoneSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    cursorIncrement() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readInt32(this.bb_pos + offset) : null;
    }
    minDataDistance() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readInt32(this.bb_pos + offset) : null;
    }
    maxDataDistance() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readInt32(this.bb_pos + offset) : null;
    }
    numEpochs() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readInt32(this.bb_pos + offset) : null;
    }
    printEveryNumEpochs() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readInt32(this.bb_pos + offset) : null;
    }
    initialAdjustRate() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    adjustRateDecay() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    slideErrorFactor() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    offsetSlideErrorFactor() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    footHeightOffsetErrorFactor() {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    bodyProportionErrorFactor() {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    heightErrorFactor() {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    positionErrorFactor() {
        const offset = this.bb.__offset(this.bb_pos, 28);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    positionOffsetErrorFactor() {
        const offset = this.bb.__offset(this.bb_pos, 30);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    calcInitError() {
        const offset = this.bb.__offset(this.bb_pos, 32);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    randomizeFrameOrder() {
        const offset = this.bb.__offset(this.bb_pos, 34);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    scaleEachStep() {
        const offset = this.bb.__offset(this.bb_pos, 36);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    sampleCount() {
        const offset = this.bb.__offset(this.bb_pos, 38);
        return offset ? this.bb.readInt32(this.bb_pos + offset) : null;
    }
    sampleRateMs() {
        const offset = this.bb.__offset(this.bb_pos, 40);
        return offset ? this.bb.readInt64(this.bb_pos + offset) : null;
    }
    saveRecordings() {
        const offset = this.bb.__offset(this.bb_pos, 42);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    useSkeletonHeight() {
        const offset = this.bb.__offset(this.bb_pos, 44);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    randSeed() {
        const offset = this.bb.__offset(this.bb_pos, 46);
        return offset ? this.bb.readInt64(this.bb_pos + offset) : null;
    }
    static startAutoBoneSettings(builder) {
        builder.startObject(22);
    }
    static addCursorIncrement(builder, cursorIncrement) {
        builder.addFieldInt32(0, cursorIncrement, 0);
    }
    static addMinDataDistance(builder, minDataDistance) {
        builder.addFieldInt32(1, minDataDistance, 0);
    }
    static addMaxDataDistance(builder, maxDataDistance) {
        builder.addFieldInt32(2, maxDataDistance, 0);
    }
    static addNumEpochs(builder, numEpochs) {
        builder.addFieldInt32(3, numEpochs, 0);
    }
    static addPrintEveryNumEpochs(builder, printEveryNumEpochs) {
        builder.addFieldInt32(4, printEveryNumEpochs, 0);
    }
    static addInitialAdjustRate(builder, initialAdjustRate) {
        builder.addFieldFloat32(5, initialAdjustRate, 0);
    }
    static addAdjustRateDecay(builder, adjustRateDecay) {
        builder.addFieldFloat32(6, adjustRateDecay, 0);
    }
    static addSlideErrorFactor(builder, slideErrorFactor) {
        builder.addFieldFloat32(7, slideErrorFactor, 0);
    }
    static addOffsetSlideErrorFactor(builder, offsetSlideErrorFactor) {
        builder.addFieldFloat32(8, offsetSlideErrorFactor, 0);
    }
    static addFootHeightOffsetErrorFactor(builder, footHeightOffsetErrorFactor) {
        builder.addFieldFloat32(9, footHeightOffsetErrorFactor, 0);
    }
    static addBodyProportionErrorFactor(builder, bodyProportionErrorFactor) {
        builder.addFieldFloat32(10, bodyProportionErrorFactor, 0);
    }
    static addHeightErrorFactor(builder, heightErrorFactor) {
        builder.addFieldFloat32(11, heightErrorFactor, 0);
    }
    static addPositionErrorFactor(builder, positionErrorFactor) {
        builder.addFieldFloat32(12, positionErrorFactor, 0);
    }
    static addPositionOffsetErrorFactor(builder, positionOffsetErrorFactor) {
        builder.addFieldFloat32(13, positionOffsetErrorFactor, 0);
    }
    static addCalcInitError(builder, calcInitError) {
        builder.addFieldInt8(14, +calcInitError, 0);
    }
    static addRandomizeFrameOrder(builder, randomizeFrameOrder) {
        builder.addFieldInt8(15, +randomizeFrameOrder, 0);
    }
    static addScaleEachStep(builder, scaleEachStep) {
        builder.addFieldInt8(16, +scaleEachStep, 0);
    }
    static addSampleCount(builder, sampleCount) {
        builder.addFieldInt32(17, sampleCount, 0);
    }
    static addSampleRateMs(builder, sampleRateMs) {
        builder.addFieldInt64(18, sampleRateMs, BigInt(0));
    }
    static addSaveRecordings(builder, saveRecordings) {
        builder.addFieldInt8(19, +saveRecordings, 0);
    }
    static addUseSkeletonHeight(builder, useSkeletonHeight) {
        builder.addFieldInt8(20, +useSkeletonHeight, 0);
    }
    static addRandSeed(builder, randSeed) {
        builder.addFieldInt64(21, randSeed, BigInt(0));
    }
    static endAutoBoneSettings(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createAutoBoneSettings(builder, cursorIncrement, minDataDistance, maxDataDistance, numEpochs, printEveryNumEpochs, initialAdjustRate, adjustRateDecay, slideErrorFactor, offsetSlideErrorFactor, footHeightOffsetErrorFactor, bodyProportionErrorFactor, heightErrorFactor, positionErrorFactor, positionOffsetErrorFactor, calcInitError, randomizeFrameOrder, scaleEachStep, sampleCount, sampleRateMs, saveRecordings, useSkeletonHeight, randSeed) {
        AutoBoneSettings.startAutoBoneSettings(builder);
        if (cursorIncrement !== null)
            AutoBoneSettings.addCursorIncrement(builder, cursorIncrement);
        if (minDataDistance !== null)
            AutoBoneSettings.addMinDataDistance(builder, minDataDistance);
        if (maxDataDistance !== null)
            AutoBoneSettings.addMaxDataDistance(builder, maxDataDistance);
        if (numEpochs !== null)
            AutoBoneSettings.addNumEpochs(builder, numEpochs);
        if (printEveryNumEpochs !== null)
            AutoBoneSettings.addPrintEveryNumEpochs(builder, printEveryNumEpochs);
        if (initialAdjustRate !== null)
            AutoBoneSettings.addInitialAdjustRate(builder, initialAdjustRate);
        if (adjustRateDecay !== null)
            AutoBoneSettings.addAdjustRateDecay(builder, adjustRateDecay);
        if (slideErrorFactor !== null)
            AutoBoneSettings.addSlideErrorFactor(builder, slideErrorFactor);
        if (offsetSlideErrorFactor !== null)
            AutoBoneSettings.addOffsetSlideErrorFactor(builder, offsetSlideErrorFactor);
        if (footHeightOffsetErrorFactor !== null)
            AutoBoneSettings.addFootHeightOffsetErrorFactor(builder, footHeightOffsetErrorFactor);
        if (bodyProportionErrorFactor !== null)
            AutoBoneSettings.addBodyProportionErrorFactor(builder, bodyProportionErrorFactor);
        if (heightErrorFactor !== null)
            AutoBoneSettings.addHeightErrorFactor(builder, heightErrorFactor);
        if (positionErrorFactor !== null)
            AutoBoneSettings.addPositionErrorFactor(builder, positionErrorFactor);
        if (positionOffsetErrorFactor !== null)
            AutoBoneSettings.addPositionOffsetErrorFactor(builder, positionOffsetErrorFactor);
        if (calcInitError !== null)
            AutoBoneSettings.addCalcInitError(builder, calcInitError);
        if (randomizeFrameOrder !== null)
            AutoBoneSettings.addRandomizeFrameOrder(builder, randomizeFrameOrder);
        if (scaleEachStep !== null)
            AutoBoneSettings.addScaleEachStep(builder, scaleEachStep);
        if (sampleCount !== null)
            AutoBoneSettings.addSampleCount(builder, sampleCount);
        if (sampleRateMs !== null)
            AutoBoneSettings.addSampleRateMs(builder, sampleRateMs);
        if (saveRecordings !== null)
            AutoBoneSettings.addSaveRecordings(builder, saveRecordings);
        if (useSkeletonHeight !== null)
            AutoBoneSettings.addUseSkeletonHeight(builder, useSkeletonHeight);
        if (randSeed !== null)
            AutoBoneSettings.addRandSeed(builder, randSeed);
        return AutoBoneSettings.endAutoBoneSettings(builder);
    }
    unpack() {
        return new AutoBoneSettingsT(this.cursorIncrement(), this.minDataDistance(), this.maxDataDistance(), this.numEpochs(), this.printEveryNumEpochs(), this.initialAdjustRate(), this.adjustRateDecay(), this.slideErrorFactor(), this.offsetSlideErrorFactor(), this.footHeightOffsetErrorFactor(), this.bodyProportionErrorFactor(), this.heightErrorFactor(), this.positionErrorFactor(), this.positionOffsetErrorFactor(), this.calcInitError(), this.randomizeFrameOrder(), this.scaleEachStep(), this.sampleCount(), this.sampleRateMs(), this.saveRecordings(), this.useSkeletonHeight(), this.randSeed());
    }
    unpackTo(_o) {
        _o.cursorIncrement = this.cursorIncrement();
        _o.minDataDistance = this.minDataDistance();
        _o.maxDataDistance = this.maxDataDistance();
        _o.numEpochs = this.numEpochs();
        _o.printEveryNumEpochs = this.printEveryNumEpochs();
        _o.initialAdjustRate = this.initialAdjustRate();
        _o.adjustRateDecay = this.adjustRateDecay();
        _o.slideErrorFactor = this.slideErrorFactor();
        _o.offsetSlideErrorFactor = this.offsetSlideErrorFactor();
        _o.footHeightOffsetErrorFactor = this.footHeightOffsetErrorFactor();
        _o.bodyProportionErrorFactor = this.bodyProportionErrorFactor();
        _o.heightErrorFactor = this.heightErrorFactor();
        _o.positionErrorFactor = this.positionErrorFactor();
        _o.positionOffsetErrorFactor = this.positionOffsetErrorFactor();
        _o.calcInitError = this.calcInitError();
        _o.randomizeFrameOrder = this.randomizeFrameOrder();
        _o.scaleEachStep = this.scaleEachStep();
        _o.sampleCount = this.sampleCount();
        _o.sampleRateMs = this.sampleRateMs();
        _o.saveRecordings = this.saveRecordings();
        _o.useSkeletonHeight = this.useSkeletonHeight();
        _o.randSeed = this.randSeed();
    }
}
exports.AutoBoneSettings = AutoBoneSettings;
class AutoBoneSettingsT {
    constructor(cursorIncrement = null, minDataDistance = null, maxDataDistance = null, numEpochs = null, printEveryNumEpochs = null, initialAdjustRate = null, adjustRateDecay = null, slideErrorFactor = null, offsetSlideErrorFactor = null, footHeightOffsetErrorFactor = null, bodyProportionErrorFactor = null, heightErrorFactor = null, positionErrorFactor = null, positionOffsetErrorFactor = null, calcInitError = null, randomizeFrameOrder = null, scaleEachStep = null, sampleCount = null, sampleRateMs = null, saveRecordings = null, useSkeletonHeight = null, randSeed = null) {
        this.cursorIncrement = cursorIncrement;
        this.minDataDistance = minDataDistance;
        this.maxDataDistance = maxDataDistance;
        this.numEpochs = numEpochs;
        this.printEveryNumEpochs = printEveryNumEpochs;
        this.initialAdjustRate = initialAdjustRate;
        this.adjustRateDecay = adjustRateDecay;
        this.slideErrorFactor = slideErrorFactor;
        this.offsetSlideErrorFactor = offsetSlideErrorFactor;
        this.footHeightOffsetErrorFactor = footHeightOffsetErrorFactor;
        this.bodyProportionErrorFactor = bodyProportionErrorFactor;
        this.heightErrorFactor = heightErrorFactor;
        this.positionErrorFactor = positionErrorFactor;
        this.positionOffsetErrorFactor = positionOffsetErrorFactor;
        this.calcInitError = calcInitError;
        this.randomizeFrameOrder = randomizeFrameOrder;
        this.scaleEachStep = scaleEachStep;
        this.sampleCount = sampleCount;
        this.sampleRateMs = sampleRateMs;
        this.saveRecordings = saveRecordings;
        this.useSkeletonHeight = useSkeletonHeight;
        this.randSeed = randSeed;
    }
    pack(builder) {
        return AutoBoneSettings.createAutoBoneSettings(builder, this.cursorIncrement, this.minDataDistance, this.maxDataDistance, this.numEpochs, this.printEveryNumEpochs, this.initialAdjustRate, this.adjustRateDecay, this.slideErrorFactor, this.offsetSlideErrorFactor, this.footHeightOffsetErrorFactor, this.bodyProportionErrorFactor, this.heightErrorFactor, this.positionErrorFactor, this.positionOffsetErrorFactor, this.calcInitError, this.randomizeFrameOrder, this.scaleEachStep, this.sampleCount, this.sampleRateMs, this.saveRecordings, this.useSkeletonHeight, this.randSeed);
    }
}
exports.AutoBoneSettingsT = AutoBoneSettingsT;
